export default '80FD8';
